import { Outlet } from 'react-router';
import styled from '@emotion/styled';

const Container = styled.div`
  min-height: 100%;
  text-align: left;
  background: none;
`;

const AccountManagementPage = () => {
  return (
    <Container>
      <Outlet></Outlet>
    </Container>
  );
};

export default AccountManagementPage;
